import React from 'react';
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";

export default function CounterSection({ about }) {
    const { i18n } = useTranslation(["navbar"]);
    let lang = i18n.language || "ar";
    if (!about?.counterTitle1) return null;
    return (
        <section className="trust" id='aboutUsElmenet'>
            <div className="ctn">
                <div className="trust-row">
                    <div className="trust-content">
                        <div className="stag">{about?.title?.replace(/<br\s*\/?>/gi, ' ')}</div>
                        <p className="text-16 text-t3 leading-relaxed max-w-2xl">
                            {about?.desc?.replace(/<br\s*\/?>/gi, ' ')}
                        </p>
                    </div>

                    <div className="trust-stats">
                        <div className="ts">
                            <div className="ts-num">
                                <CountUp end={about?.counter1 || 0} duration={3} enableScrollSpy scrollSpyOnce />
                                K+
                            </div>
                            <div className="ts-label">{about?.counterTitle1}</div>
                        </div>
                        <div className="ts">
                            <div className="ts-num">
                                <CountUp end={about?.counter2 || 0} duration={3} enableScrollSpy scrollSpyOnce />
                                +
                            </div>
                            <div className="ts-label">{about?.counterTitle2}</div>
                        </div>
                        <div className="ts">
                            <div className="ts-num">
                                <CountUp end={about?.counter3 || 0} duration={3} enableScrollSpy scrollSpyOnce />
                                +
                            </div>
                            <div className="ts-label">{about?.counterTitle3}</div>
                        </div>
                        <div className="ts">
                            <div className="ts-num">2</div>
                            <div className="ts-label">{lang === 'ar' ? 'معارض' : 'Showrooms'}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}